module.exports = __webpack_public_path__ + "img/exc_6.b416e2f0.webp";